<template>
	<div class="Creditos">

		<div>
			<div>
				<p>Prefeitura de São Paulo</p>
			</div>
			<div>
				<p>João Doria</p>
				<p>Prefeito</p>
			</div>
			<div>
				<p>Bruno Covas</p>
				<p>Vice Prefeito</p>
			</div>
		</div>
		<div>
			<p>Coordenação</p>
			<p>Secretaria Municipal de Urbanismo e Licenciamento</p>
		</div>
		<div>
			<div>
				<p>Lei nº 16.642/2017</p>
			</div>
			<div>
				<p>Coordenação</p>
				<p>Secretaria Municipal de Licenciamento</p>
			</div>
			<div>
				<p>Secretarias Municipais</p>
				<p>Secretaria Municipal de Coordenação das Subprefeituras</p>
				<p>Secretaria Municipal de Desenvolvimento Urbano</p>
				<p>Secretaria Municipal de Finanças e Desenvolvimento Econômico</p>
				<p>Secretaria Municipal de Governo</p>
				<p>Secretaria Municipal de Infra Estrutura Urbana</p>
				<p>Secretaria Municipal de Negócios Jurídicos</p>
				<p>Secretaria Municipal da Pessoa com Deficiência e Mobilidade Reduzida</p>
				<p>Secretaria Municipal de Transportes</p>
				<p>Secretaria Municipal de Verde e Meio Ambiente</p>
			</div>
		</div>
		<div>
			<div>
				<p>Decreto nº 57.776/2017</p>
			</div>
			<div>
				<p>Coordenação</p>
				<p>Secretaria Municipal de Urbanismo e Licenciamento</p>
			</div>
			<div>
				<p>Secretarias Municipais</p>
				<p>Secretaria Municipal das Prefeituras Regionais</p>
				<p>Secretaria Municipal de Governo</p>
				<p>Secretaria Municipal de Serviços e Obras</p>
				<p>Secretaria Municipal de Justiça</p>
				<p>Secretaria Municipal da Pessoa com Deficiência </p>
				<p>Secretaria Municipal de Mobilidade e Transportes</p>
				<p>Secretaria Municipal de Verde e Meio Ambiente</p>
			</div>
		</div>
		<div>
			<div>
				<p>Conforme registros dos processos administrativos correspondentes, também participaram da elaboração da Lei nº 16.642/2017 e do Decreto nº 57.776/2017 as seguintes entidades:</p>
			</div>
			<div>
				<p>ABRAINC - Associação Brasileira de Incorporadoras Imobiliárias</p>
				<p>ASBEA - Associação Brasileira dos Escritórios de Arquitetura</p>
				<p>SECOVI - Sindicato das Empresas de Compra, Venda, Locação e Administração de Imóveis Residenciais e Comerciais de São Paulo</p>
				<p>SINDUSCON - Sindicato da Indústria da Construção Civil do Estado de São Paulo</p>
			</div>
			<div>
				<p>Outros colaboradores</p>
				<p>ABRASCE - Associação Brasileira de Shopping Centers</p>
				<p>CAU – Conselho de Arquitetura e Urbanismo</p>
				<p>Comgás - Companhia de Gás de São Paulo</p>
				<p>Corpo de Bombeiros do Estado de São Paulo</p>
				<p>Metrô - Companhia do Metropolitano de São Paulo</p>
				<p>PRODAM - Empresa de Tecnologia da Informação e Comunicação do Município de São Paulo</p>
				<p>UNIFESP - Universidade Federal de São Paulo</p>
				<p>USP - Universidade de São Paulo</p>
			</div>
		</div>

	</div>
</template>

<script>
export default{
  name: "Creditos", 
  data(){
    return{
      title: "Créditos"
    }
  }
}
</script>

<style lang="scss">
@import '../assets/main.scss';
</style>


// WEBPACK FOOTER //
// src/components/Creditos.vue